export default {
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(() => {
          const data = this.getAllData();
          if (!this.form.receiptAddressId) {
            this.$notify.error({
              message: '请选择收货地址'
            });
            resolve(false);
            return;
          }
          resolve(data);
        }).catch(() => {
          this.$notify.error({
            message: '合同基本信息存在必填字段未填写完成，请检查后填写'
          });
          resolve(false);
        });
      });
    },
    validatedrafts () {
      if (!this.form.contractNum || !this.form.projectName) {
        this.$notify.error({
          message: '供货单位、订单分类、项目名称为必填字段，请填写完成'
        });
        return false;
      }
      const data = this.getAllData();
      return data;
    },
    getAllData () {
      const contractInfo = {
        contractNum: this.form.contractNum,
        customerContractNum: this.form.customerContractNum,
        projectName: this.form.projectName,
        isOrderAdminCreate: this.form.isOrderAdminCreate,
        contractType: this.form.contractType,
        id: this.form.id,
        contractStatus: 0
      };
      const contractDetail = {
        id: this.form.contractDetailId,
        supplyUnitId: this.form.supplyUnitId,
        orderUnitCode: this.form.orderUnitCode,
        orderUnit: this.form.orderUnit,
        orderUnitPhone: this.form.orderUnitPhone,
        finalCustomer: this.form.finalCustomer,
        customerContractType: this.form.customerContractType,
        regionCode: this.form.regionCode,
        regionName: this.form.regionName,
        regionBusinessCommissionerId: this.form.regionBusinessCommissionerId,
        regionBusinessCommissioner: this.form.regionBusinessCommissioner,
        regionBusinessCommissionerOpinion: this.form.regionBusinessCommissionerOpinion,
        salesManCode: this.form.salesManCode,
        salesManName: this.form.salesManName,
        tradeTerm: this.form.tradeTerm,
        departmentCode: this.form.departmentCode,
        departmentName: this.form.departmentName,
        preSalesCode: this.form.preSalesCode,
        preSalesName: this.form.preSalesName,
        meteringPoint: this.form.meteringPoint,
        isEmbeddedSoftware: this.form.isEmbeddedSoftware,
        salesType: this.form.salesType,
        paymentBankId: this.form.paymentBankId,
        accountPeriod: this.form.accountPeriod,
        shipType: this.form.shipType,
        isRebate: this.form.isRebate,
        // isRebate: 0,
        rebateAmount: this.form.rebateAmount,
        warehouse: this.form.warehouse || '',
        // 如果是国际服务订单,直接取当前V2接口中返回formTaxRate 否则取原来的
        formTaxRate: this.isShowInternationalServiceOrders === 1 ? this.formTaxRate : this.form.formTaxRate,
        remainderRebateAmount: this.form.remainderRebateAmount,
        receiptAddressId: this.form.receiptAddressId,
        additionalTerms: this.form.additionalTerms,
        remarks: this.form.remarks,
        deliverRemark: this.form.deliverRemark,
        invoiceRemark: this.form.invoiceRemark,
        isDistributorParticipate: this.form.isDistributorParticipate,
        integratorCode: this.form.integratorCode,
        integratorName: this.form.integratorName,
        integratorType: this.form.integratorType,
        finalIntegratorsId: this.form.finalIntegratorsId,
        finalIntegratorsName: this.form.finalIntegratorsName,
        finalIntegratorsType: this.form.finalIntegratorsType,
        metrologyIntegratorCode: this.form.metrologyIntegratorCode,
        metrologyIntegratorName: this.form.metrologyIntegratorName,
        metrologyIntegratorType: this.form.metrologyIntegratorType,
        currencyId: this.form.currencyId,
        currencyName: this.form.currencyName,
        crmAccountCode: this.form.crmAccountCode,
        saleModesName: this.form.saleModesName,
        saleModesCode: this.form.saleModesCode,
        finalCustomerEmail: this.form.finalCustomerEmail,
        paymentMethodCode: this.form.paymentMethodCode,
        paymentMethodName: this.form.paymentMethodName,
        settlementMethod: this.form.settlementMethod,
        opportunityCode: this.form.opportunityCode,
        marketSegmentCode: this.form.marketSegmentCode,
        opportunityName: this.form.opportunityName,
        marketSegmentName: this.form.marketSegmentName,
        applicationScenariosCode: this.form.applicationScenariosCode,
        applicationScenariosName: this.form.applicationScenariosName,
        applicationSceneName: this.form.applicationSceneName,
        applicationSceneCode: this.form.applicationSceneCode,
        isTestProject: this.form.isTestProject,
        rebate: this.form.rebate,
        communicationOrderDiscount: this.form.communicationOrderDiscount,
        soldCountry: this.form.soldCountry,
        projectCode: this.form.projectCode,
        serviceTerms: this.form.serviceTerms,
        receiptArrivalAcceptanceRequirements: this.form.receiptArrivalAcceptanceRequirements,
        borrowingOrderNumber: this.form.borrowingOrderNumber,
        isSpecialPrice: this.form.isSpecialPrice,
        powerCordSpecification: this.form.powerCordSpecification,
        netSales: this.form.netSales,
        saleTypeCode: this.form.saleTypeCode,
        saleTypeName: this.form.saleTypeName,
        setNoticeMail: this.form.setNoticeMail,
        authorizationEmail: this.form.authorizationEmail,
        modeOfShipping: this.form.modeOfShipping,
        destination: this.form.destination,
        atAfterSight: this.form.atAfterSight,
        sightDate: this.form.sightDate,
        secondChannelName: this.form.secondChannelName
      };
      const supplyUnitPhone = this.form.supplyPhone;
      const threePlugPowerCord = this.form.threePlugPowerCord;
      const civilInternational = this.isShowInternationalServiceOrders ? this.isShowInternationalServiceOrders : ''; // 是否输入国际服务订单
      return { contractInfo, contractDetail, supplyUnitPhone, threePlugPowerCord, civilInternational };
    },
    changeSupply (val) {
      this.$refs.bank.searchBank({ 'id': val.id });
      this.$refs.contractNumber.initData(val.unitAbbreviation);
      if (this.$refs.orderType) {
        // this.$refs.orderType.initContratOrderType(val.code);
        this.$refs.orderType.changeTaxType(this.form);
      }
      if (this.$refs.rebateAmount) {
        this.$refs.rebateAmount.changeEndCustomer(this.form);
      }
    },
    changeOrderState (val) {
      this.$refs.contractNumber.initData(this.form.unitAbbreviation);
    },
    changeOrderUnit () {
      if (this.$refs.rebateAmount) {
        this.$refs.rebateAmount.changeEndCustomer(this.form);
      }
    },
    changeEndUnit () {
      if (this.$refs.rebateAmount) {
        this.$refs.rebateAmount.changeEndCustomer(this.form);
      }
    },
    changeTaxType () {
      if (this.$refs.orderType) {
        this.$refs.orderType.changeTaxType(this.form);
      }
    }
  }
};
